import './css/Nav.css';
import { Link } from 'react-router-dom';

function Nav() {
  return (
    <div className="Nav">
      <Link to="/">Home</Link>
      |
      <Link to="/about">About Us</Link>
      |
      <Link to="/portfolio">Portfolio</Link>
      |
      <a href="https://gillassociatesphotography.pixieset.com/" target="_blank" rel="noreferrer">Gallery</a>
      |
      <Link to="/other-services">Other Services</Link>
      |
      <Link to="/location">Location</Link>
      |
      <Link to="/contact">Contact</Link>
      |
      <Link to="/passwordrequest">Password Request</Link>
    </div>
  );
}

export default Nav;
